import {ChangeDetectorRef, Component} from '@angular/core';
import {CtModelConfiguration, CtModelRouteData, CtModelService, CtModelType} from "@ctsolution/ct-framework";
import {ActivatedRoute} from "@angular/router";
import {UserRouteData} from "../../../_core/route-data/user.route-data";
import {CtFieldCustomColumn} from "@ctsolution/ct-framework/lib/ct-datatable/_core/ct-field-custom.column";
import {Role} from "../../../_core/enum/role";
import {UserFeeManagerConfiguration} from "../user-fee-manager/user-fee-manager.configuration";
import {CtManagerService} from "../../../_core/lib/ct-manager.service";
import { ChangePasswordParameter, CtAuthenticationService, CtProfileService } from '@ctsolution/ct-authentication';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { UserChangePasswordDialogComponent, UserChangePasswordResult } from './user-change-password-dialog/user-change-password-dialog.component';
import { JwtService } from '../../../_core/lib/jwt.service';

@Component({
  selector: 'app-user-edit',
  template: `
    <ct-model *ngIf="configuration" [configuration]="configuration"></ct-model>

    <ng-container *ngIf="enableFeeManager">
      <div class="ct-manager-master-detail-container">
        <app-user-fee-manager [configuration]="userFeeManagerConfiguration"></app-user-fee-manager>
      </div>
    </ng-container>

    <ng-container *ngIf="enableMasterDetail && this.viewModel.MONITORING">

      <app-user-info-work-data></app-user-info-work-data>

    </ng-container>

    <!-- Sezione cambio password - visibile solo se sono nel dettaglio del mio utente -->
    <ng-container *ngIf="enableMasterDetail && isUserHimself">
        <app-change-password-card
    *ngIf="!isLoading"
    title="Account"
    description="Modifica la tua password"
    buttonLabel="Modifica Password">
  </app-change-password-card>
    </ng-container>
  `,
  styles: [`
    /* Card container per la sezione cambio password */
    :host ::ng-deep .change-password-card {
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #e0e0e0;
      padding: 24px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
      transition: box-shadow 0.3s ease;
      margin: 20px 15px !important;
    }

    .change-password-card:hover {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    /* Header della card con icona e testi */
    .card-header {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 20px;
      padding-bottom: 16px;
      border-bottom: 1px solid #f0f0f0;
    }

    .header-icon {
      color: #006595; /* Colore primario dal tuo progetto */
      font-size: 32px;
      width: 32px;
      height: 32px;
    }

    .header-content {
      flex: 1;
    }

    .card-title {
      margin: 0;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      line-height: 1.4;
    }

    .card-description {
      margin: 4px 0 0 0;
      font-size: 14px;
      color: #666666;
      line-height: 1.5;
    }

    /* Sezione azioni con il pulsante */
    .card-actions {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .card-actions button {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 0 24px;
      height: 40px;
      font-size: 14px;
      font-weight: 500;
    }

    .card-actions button mat-icon {
      font-size: 20px;
      width: 20px;
      height: 20px;
    }
  `]
})
export class UserEditComponent {

  configuration: CtModelConfiguration<UserEditComponent> | null = null;
  userFeeManagerConfiguration: UserFeeManagerConfiguration = UserFeeManagerConfiguration
    .create();

  isUserHimself: boolean = false;

  viewModel = {
    CRM: false,
    MONITORING : false
  }

  get enableMasterDetail(): boolean {
    return !!this.configuration?.RouteData?.id;
  }

  get userHasAgentRole() {
    return this.configuration?.form?.value?.Role?.toLowerCase() === Role.AGENT.toLowerCase();
  }

  get enableFeeManager() {
    return this.userHasAgentRole && this.enableMasterDetail && this.viewModel.CRM;
  }

  constructor(
    private route: ActivatedRoute,
    private managerService: CtManagerService,
    private cdr : ChangeDetectorRef,
    private jwtService : JwtService,
    private modelService : CtModelService <any>
  ) {
  }

  ngAfterViewInit() {

    this.setup();

    this.route
    .data
    .subscribe(data => {
      data['title'] = 'CT_PAGE.BREADCRUMBS.DetailUser';
      this.cdr.detectChanges();
    })

  }

  async setup() {

    const routeData: CtModelRouteData = UserRouteData()
      .setModelType(CtModelType.FORM);

    const pId: string | null = this.route.snapshot.paramMap.get("id");

    if (pId) {

      routeData
        .setId(+pId);

      this.userFeeManagerConfiguration
        .setUserOid(routeData.id)

      this.isUserHimself = await this.checkUser(pId);

    }

    this.viewModel.CRM = await this.managerService.hasEnabled.CRM() ?? false;
    this.viewModel.MONITORING = await this.managerService.hasEnabled.monitoring() ?? false;
    const userHasMonitoringManagementEnabled = await this.managerService.hasEnabled.monitoring() ?? false;

    const fieldsCustomTemplates: CtFieldCustomColumn[] = [
      {prop: "DailyWorkingHours", visible: userHasMonitoringManagementEnabled},
      {prop: "WeeklyWorkingHours", visible: userHasMonitoringManagementEnabled},
      {prop: "WorkJob", visible: userHasMonitoringManagementEnabled},
    ];

    this.configuration = CtModelConfiguration
      .create<UserEditComponent>()
      .setRouteData(routeData)
      .setFieldsCustomTemplates(fieldsCustomTemplates)

  }

  async checkUser(oid : string) {
    const a = await this.jwtService.getUserInfoOid();
    if (a === oid) return true;
    return false;
  }

}
